import { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import cn from 'classnames'
import { differenceInSeconds, parseISO } from 'date-fns'

import { OtpCountdown } from './DurationTimer.styled'

export const DurationTimer = ({ setCustomExpired }) => {
  const { challenge } = useSelector(
    ({ auth: { challenge } }) => ({
      challenge
    }),
    shallowEqual
  )

  const { end, initialSeconds } = useMemo(() => {
    if (challenge?.validUntil) {
      const endTime = parseISO(challenge.validUntil)
      return {
        end: endTime,
        initialSeconds: Math.max(0, differenceInSeconds(endTime, new Date()))
      }
    }
    return { end: null, initialSeconds: 0 }
  }, [challenge])

  const [expired, setExpired] = useState(false)
  const [remainingSeconds, setRemainingSeconds] = useState(initialSeconds)

  useEffect(() => {
    if (end && remainingSeconds > 0) {
      const timerId = setInterval(() => {
        setRemainingSeconds(prev => {
          const newValue = prev - 1
          if (newValue <= 0) {
            setExpired(true)
            setCustomExpired?.(true)
            return 0
          }
          return newValue
        })
      }, 1000)

      return () => {
        clearInterval(timerId)
      }
    }
  }, [end, remainingSeconds, setCustomExpired])

  const formatTimer = (num: number) => {
    if (num > 0) {
      return num < 10 ? `0${num}` : num
    }
    return '00'
  }

  const minutes = Math.floor(remainingSeconds / 60)
  const seconds = remainingSeconds % 60

  return (
    <OtpCountdown className={cn({ expired })}>
      {formatTimer(minutes)}:{formatTimer(seconds)}
    </OtpCountdown>
  )
}
